import { render, staticRenderFns } from "./notice-details.vue?vue&type=template&id=2ea2ce6d&scoped=true&"
import script from "./notice-details.vue?vue&type=script&lang=js&"
export * from "./notice-details.vue?vue&type=script&lang=js&"
import style0 from "./notice-details.vue?vue&type=style&index=0&id=2ea2ce6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea2ce6d",
  null
  
)

export default component.exports